import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/inherits";
import axios from "axios";
import BaseData from "./BaseData";

var SpecialNeedsServiceEnrichedProviders =
/*#__PURE__*/
function (_BaseData) {
  _inherits(SpecialNeedsServiceEnrichedProviders, _BaseData);

  function SpecialNeedsServiceEnrichedProviders() {
    _classCallCheck(this, SpecialNeedsServiceEnrichedProviders);

    return _possibleConstructorReturn(this, _getPrototypeOf(SpecialNeedsServiceEnrichedProviders).call(this, "SpecialNeedsServiceEnrichedProviders"));
  }

  _createClass(SpecialNeedsServiceEnrichedProviders, [{
    key: "GetByHousingId",
    value: function () {
      var _GetByHousingId = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(housingPriorityCertificationId) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", axios.get("/api/".concat(this._controller, "/GetByHousingId/").concat(housingPriorityCertificationId)));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function GetByHousingId(_x) {
        return _GetByHousingId.apply(this, arguments);
      }

      return GetByHousingId;
    }()
  }]);

  return SpecialNeedsServiceEnrichedProviders;
}(BaseData);

export default new SpecialNeedsServiceEnrichedProviders();